import { render } from "./RelationshipInactiveNotice.vue?vue&type=template&id=4c75cdc0&scoped=true"
import script from "./RelationshipInactiveNotice.vue?vue&type=script&lang=js"
export * from "./RelationshipInactiveNotice.vue?vue&type=script&lang=js"

import "./RelationshipInactiveNotice.vue?vue&type=style&index=0&id=4c75cdc0&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4c75cdc0"]])

export default __exports__